// src/lib/stores/miniPlayerStore.ts
import { writable } from 'svelte/store';
import { browser } from '$app/environment';

export const currentVideoId = writable<string | null>(null);
export const isPlaying = writable<boolean>(false);
export const platform = writable<'youtube' | 'twitch'>('youtube');
export const twitchId = writable<string | null>(null);

// 初期値の設定
const initialMiniPlayerEnabled = browser ? localStorage.getItem('miniPlayerEnabled') === 'false' ? false : true : true;
const initialMiniPlayerActive = false; // ブラウザリロード時は必ずfalseから開始

export const isMiniPlayerEnabled = writable(initialMiniPlayerEnabled);
export const isMiniPlayerActive = writable(initialMiniPlayerActive);

// 値が変更されたらローカルストレージに保存
if (browser) {
  isMiniPlayerEnabled.subscribe(value => {
    localStorage.setItem('miniPlayerEnabled', value.toString());
  });
}

export function updateMiniPlayer(videoId: string | null, playing: boolean | null, platformValue: string = 'youtube', twitchIdValue: string | null = null) {
    currentVideoId.set(videoId);
    isPlaying.set(playing);
    platform.set(platformValue);
    twitchId.set(twitchIdValue);
    isMiniPlayerActive.set(!!videoId);
}